'use strict';
const drawerInsuranceFactory = require('components/insurances/drawer_insurance/js/main');
const DrawerModel = require('components/ui/drawer/js/model');
const trackingUtils = require('../../modules/utils/tracking.utils');
const StopInfoView = require('../../modules/views/flight_summary/stop_info.view');
const StopInfoTechnicalView = require('../../modules/views/flight_summary/stop_info_technical.view');
const stopInfoUtils = require('od-modules/utils/flight_summary/stop_info.utils');
const airlineUtils = require('../../modules/utils/airlines');
const tripTypeUtils = require('../../modules/utils/trip_type');
const ipTouchpoint = require('components/cross_selling/ip_touchpoint/js/main');
const flightChangeFreeUtil = require('../../modules/utils/flight_change_free');
const {hasRememberMeCookie} = require('od-modules/utils/sso.utils');
const fareOptionInfoFactory = require('components/fare_option_info/js/main');
const Modal = require('../../modules/ui/modal');
const {isNullOrUndefined} = require('od-modules/utils/sorting.pb.utils');
const insuranceCatalogueCollection = require('../../modules/collections/insurance_catalogue.collection').getInstance();
const FLEXIBILITY_DISRUPTION_MODAL_CLASS_WRAPPER = 'flexibility_disruption_popup';
const FLEXIBILITY_DISRUPTION_GENERIC_TEMPLATES = 'flexibility_disruption';
const FLIGHT_CHANGE_FREE_GENERIC_TEMPLATES = 'flight_change_free';
const FLIGHT_FLEXIBILITY_GENERIC_TEMPLATES = 'flight_flexibility';
const AIRLINE_CAMPAIGN_GENERIC_TEMPLATES = 'airline_campaign';

const FLEX_MODAL_WHEN_SELECTOR = '.flex_when_option';
const FLEX_MODAL_WHAT_SELECTOR = '.flex_what_option';
const FLEX_MODAL_HOW_SELECTOR = '.flex_how_option';
const NEW_DETAILS_TEMPLATE = 'resultsNewPopupAb';

const ODIRATING_TAG = 'ODIRATING';
const NONE_TAG = 'NONE';

const DEUTSCHE_BAHN = '2A';

const isNewPopupEnabled = Odigeo.AB.isBetterDetailsWrapActive;
let isFolded = false;
let isSearchBarOpened = false;
let shallShowDetails;
let hasStops;
const isDynpack = Odigeo.Utils.isRequestApp('dp');

module.exports = {
    paxAndPayLightbox: false,

    init() {
        this.options = Odigeo.parseOptions(this.widget.options);
        this.renderDetails();
        this.viewListeners();
        isFolded = this.options.isFolded;
        if (!this.options.isResults) {
            this.model.getData();
        }
        this.updateDomSelectorsToCache();
        this.bindViewEvents();
        this.detailsModel = new Backbone.Model({
            drawer: new DrawerModel(),
        });
        this.drawerInsurance = drawerInsuranceFactory.create({
            model: this.detailsModel.get('drawer'),
        });
    },
    viewListeners() {
        this.listenTo(this.model, 'change:flightDetailsDTO', this.initTemplate);
    },
    events: {
        'mouseover @airlineLogo': 'onAirlineLogoHover',
        'mouseout @airlineLogo': 'onAirlineLogoHover',
        'tap @flightDetailsWrapper': 'toggleFlightDetails',
        'tap @collapsibleFlightDetailsWrapper': 'toggleFlightDetails',
        'tap @toggleFlightDetails': 'toggleFlightDetails',
        'tap @resultsContinueButton': 'onResultsContinueButton',
        'tap @forceSelectionBackground': 'onCloseForceSelection',
        'tap @forceSelectionCloseButton': 'onCloseForceSelection',
        'tap @forceSelectionLabel': 'onForceSelectionLabel',
        'tap @changeFlight': 'onChangeSearchButton',
        'tap @launchPopup': 'launchPopup',
        'tap @flexibilityDisruptionModalIcon': 'openFlexibilityDisruptionModal',
    },
    selectors: {
        flightDetailsWrapper: '.flight_details_wrapper',
        collapsibleFlightDetailsWrapper: '.collapsible_flight_details_wrapper',
        collapsibleHeader: '.collapsible_header',
        toggleFlightDetails: '.toggle_flight_details',
        fareConditionsContainer: '.fare_conditions_container',
        priceCollapsible: '.price_collapsible',
        decimalPriceCollapsible: '.decimal_price_collapsible',
        toggleRowButtons: '.collapse_arrow_buttons',
        bottomRowMessage: '.bottom_row_message',
        flightDetailsPopup: '.flight_details_popup',
        collapsibleButton: '.collapsible_button',
        collapsibleContainer: '.collapsible_container',
        importantInfo: '.important_info_message_popup',
        flexibilityDisruptionBanner: '.flexibility_disruption_banner',
        flightChangeFreeBanner: '.flight_change_free_banner',
        flightChangeFreeBannerAirlineCampaignContainer: '.flight_change_free_banner_airline_campaign_container',
        flightFlexibilityBanner: '.flight_flexibility_banner',
        airlineCampaign: '.airline_campaign',
        collapsibleContent: '.flight_details_wrapper .collapsible_content',
        collapsibleResultsPopupContainer: '.collapsible_popup_container',
        collapsibleResultsPopup: '.flight_summary_popup_container',
        collapsibleNewResultsPopup: '.details_as_page .flight_summary_popup_container',
        resultsCloseButton: '.flight_summary_popup_close',
        resultsContinueButton: '.flight_summary_popup_continue',
        forceSelectionBackground: '.force_selection_background',
        forceSelectionCloseButton: '.force_selection_close_button',
        forceSelectionLabel: '.force_selection_label',
        forceSelectionContainer: '.force_selection_container',
        forceSelectionRadioButton: '.force_selection_radio_button',
        resultsFooterContainer: '.flight_summary_popup_footer',
        collapseBaggageSection: '.collapsible_flight_details_wrapper .collapse_baggage_section',
        collapseBaggageIncluded: '.collapsible_flight_details_wrapper .collapse_baggage_included',
        airlineLogo: '.airline_logo',
        airlineLogoTooltip: '.airline_logo_tooltip',
        tripTo: '.your_trip_to',
        popupContainer: '.popup_container',
        popupNag: '.collapsible_popup_container',
        yourTripToNag: '.your_trip_to_nag',
        changeFlight: '.change_flight_button',
        changeFlightButtonText: '.change_flight_button_text',
        launchPopup: '.collapsible_launch_popup',
        flexibilityDisruptionModalIcon: '.flexibility_disruption_modal_icon',
        itineraryDetailsWrapper: '.itinerary_details_wrapper',
        collapsibleFlightMainWrapper: '.collapsible_flight_main_wrapper',
        carrierSeatTypeInfo: '.carrier_seat_type_info',
        recommendedItineraryTab: '.recommended_itinerary_tab',
        primeFlightSummaryWrapper: '.prime_flight_summary_wrapper',
    },
    renderDetails() {
        this.setTemplate(this.$el, this.options.template, {keys: this.keys, page: this.options.page});
        if (Odigeo.Membership.isMembershipFlexibilityD) {
            this.renderFlightFlexibilityBanner();
        } else if ((Odigeo.AB.isChangeFlightFreeChargeDesktop || Odigeo.AB.isChangeFlightFreeChargeMobile || Odigeo.AB.isPrimeDays) && !isDynpack) {
            flightChangeFreeUtil.refreshFlightChangeFreeAirlines(false).then(this.renderFlightChangeFreeBannerWhenAvailable.bind(this));
        } else {
            this.renderFlexibilityDisruptionBanner();
        }
        if (!isDynpack) {
            this.renderAirlineCampaignWhenAvailable();
        }
        this.showBoardingOptions();
    },
    renderPrimeSelection() {
        Odigeo.trigger(`${this.widget.id}:initializePrimeInFlightSummary`, this.model.get('flightDetailsDTO'));
        this.$cachedSelectors.popupNag.addClass('prime-selection');
    },

    getFlightDetailsDTO() {
        return this.model.get('flightDetailsDTO') || {};
    },

    getTransportType() {
        const flightDetailsDTO = this.getFlightDetailsDTO();
        return flightDetailsDTO.transportType || 'PLANE';
    },

    getTransportsOrdered() {
        const flightDetailsDTO = this.getFlightDetailsDTO();
        const segments = flightDetailsDTO.segments || [];
        return segments.reduce((result, actual) => {
            const actualTransport = actual.transportType.toLocaleLowerCase();
            if (actualTransport === 'mix_plane_train') {
                return ['plane', 'train'];
            } else if (result.indexOf(actualTransport) === -1) {
                result.push(actualTransport);
            }
            return result;
        }, []);
    },

    getSegmentTransports(segment) {
        const transportType = segment.transportType.toLocaleLowerCase();
        if (transportType === 'mix_plane_train') {
            return ['plane', 'train'];
        }
        return [transportType];
    },

    calculateHighlightedTag(highlightedTag) {
        if (highlightedTag === ODIRATING_TAG) {
            return highlightedTag;
        } else {
            return NONE_TAG;
        }
    },

    renderHeader() {
        const transports = this.getTransportsOrdered();
        const texts = transports
            .reduce((result, transportType) => {
                transportType = transportType.toUpperCase();

                return result.concat(this.keys[`header${transportType}`]);
            }, [])
            .join(' + ');

        this.$cachedSelectors.collapsibleHeader.html(
            this.templates.header({
                transports,
                texts,
                titleKey: this.keys.title,
            })
        );
    },

    renderFlexibilityDisruptionBanner() {
        insuranceCatalogueCollection.getLoadedPromise().then(
            Odigeo._.bind((loaded) => {
                if (loaded && insuranceCatalogueCollection.isCancellationFree()) {
                    Odigeo.Templates.getGenericTemplates([FLEXIBILITY_DISRUPTION_GENERIC_TEMPLATES]).then(
                        Odigeo._.bind(function(templates) {
                            if (Odigeo._.isObject(templates)) {
                                const flexibilityDisruptionTemplates = Odigeo._.get(templates, FLEXIBILITY_DISRUPTION_GENERIC_TEMPLATES);
                                const flexibilityDisruptionTemplatesKeys = templates.getStaticTemplatesKeys(FLEXIBILITY_DISRUPTION_GENERIC_TEMPLATES);
                                flexibilityDisruptionTemplatesKeys.flexibilityDisruptionPartition = Odigeo.AB.getFlexibilityDisruptionDesktop;
                                flexibilityDisruptionTemplatesKeys.isFlexibilityDisruptionEnabledDesktop =
                                    Odigeo.AB.isFlexibilityDisruptionEnabledDesktop;
                                this.initFlexibilityDisruptionModal(flexibilityDisruptionTemplates, flexibilityDisruptionTemplatesKeys);
                                this.setFlexibilityDisruptionBanner(flexibilityDisruptionTemplates, flexibilityDisruptionTemplatesKeys);
                            }
                        }, this)
                    );
                }
            }, this)
        );
    },
    renderFlightChangeFreeBannerWhenAvailable(segments) {
        const carriers = segments ? [...new Set(segments.map((segment) => (segment.carrier ? segment.carrier.code : null)))] : null;
        const isFlightChangeableForFree = carriers
            ? flightChangeFreeUtil.isChangeFlightFreeChargeValid(carriers)
            : flightChangeFreeUtil.isSelectedFlightChangeableForFree();
        if (isFlightChangeableForFree) {
            this.renderFlightChangeFreeBanner();
        }
    },
    renderFlightChangeFreeBanner() {
        Odigeo.Templates.getGenericTemplates([FLIGHT_CHANGE_FREE_GENERIC_TEMPLATES]).then(
            Odigeo._.bind(function(templates) {
                if (Odigeo._.isObject(templates)) {
                    const flightChangeFreeTemplates = Odigeo._.get(templates, FLIGHT_CHANGE_FREE_GENERIC_TEMPLATES);
                    const flightChangeFreeTemplatesKeys = templates.getStaticTemplatesKeys(FLIGHT_CHANGE_FREE_GENERIC_TEMPLATES);
                    this.setFlightChangeFreeBanner(flightChangeFreeTemplates, flightChangeFreeTemplatesKeys);
                }
            }, this)
        );
    },
    renderFlightFlexibilityBanner() {
        Odigeo.Templates.getGenericTemplates([FLIGHT_FLEXIBILITY_GENERIC_TEMPLATES]).then(
            Odigeo._.bind(function(templates) {
                if (Odigeo._.isObject(templates)) {
                    const flightFlexibilityTemplates = Odigeo._.get(templates, FLIGHT_FLEXIBILITY_GENERIC_TEMPLATES);
                    const flightFlexibilityTemplatesKeys = templates.getStaticTemplatesKeys(FLIGHT_FLEXIBILITY_GENERIC_TEMPLATES);
                    this.setFlightFlexibilityBanner(flightFlexibilityTemplates, flightFlexibilityTemplatesKeys);
                }
            }, this)
        );
    },

    renderAirlineCampaignWhenAvailable() {
        const campaignConfig = JSON.parse(Odigeo.Session.get('campaignConfig'));
        const hasPrimeDayCampaign = campaignConfig && campaignConfig.primeDayConfig && campaignConfig.primeDayConfig.isPrimeDayFare;
        const hasAirlineCampaign = campaignConfig && campaignConfig.airlineCampaignConfig && campaignConfig.airlineCampaignConfig.hasAirlineCampaign;
        if (!isDynpack && !hasPrimeDayCampaign && hasAirlineCampaign) this.renderAirlineCampaign();
    },
    renderAirlineCampaign() {
        Odigeo.Templates.getGenericTemplates([AIRLINE_CAMPAIGN_GENERIC_TEMPLATES]).then(
            Odigeo._.bind(function(templates) {
                if (Odigeo._.isObject(templates)) {
                    const airlineCampaignTemplates = Odigeo._.get(templates, AIRLINE_CAMPAIGN_GENERIC_TEMPLATES);
                    const airlineCampaignTemplatesKeys = templates.getStaticTemplatesKeys(AIRLINE_CAMPAIGN_GENERIC_TEMPLATES);
                    this.setAirlineCampaign(airlineCampaignTemplates, airlineCampaignTemplatesKeys);
                }
            }, this)
        );
    },

    trackWhenOnClick() {
        trackingUtils.trackEvent('free-cancellation_nag', 'free-cancellation_open-info_when_pag:pax');
    },
    trackWhatOnClick() {
        trackingUtils.trackEvent('free-cancellation_nag', 'free-cancellation_open-info_what_pag:pax');
    },
    trackHowOnClick() {
        trackingUtils.trackEvent('free-cancellation_nag', 'free-cancellation_open-info_how_pag:pax');
    },
    onCloseForceSelection() {
        this.$cachedSelectors.forceSelectionRadioButton.removeAttr('checked');
        this.$cachedSelectors.forceSelectionContainer.removeClass('open');
        this.$cachedSelectors.forceSelectionBackground.removeClass('open');
    },
    initFlexibilityDisruptionModal(flexibilityDisruptionTemplates, flexibilityDisruptionTemplatesKeys) {
        const modalTemplateBuilter = Odigeo._.get(flexibilityDisruptionTemplates, 'modals/modal', Odigeo._.noop);
        const modalContentTemplateBuilder = Odigeo._.get(flexibilityDisruptionTemplates, 'modals/content', Odigeo._.noop);
        const $modalContainer = $(`.${FLEXIBILITY_DISRUPTION_MODAL_CLASS_WRAPPER}`);
        const getFlexibilityDisruptionDesktop = Odigeo.AB.getFlexibilityDisruptionDesktop;
        const isFlexibilityDisruptionDesktop = getFlexibilityDisruptionDesktop >= 3;
        let bgImageClass;
        if (isFlexibilityDisruptionDesktop) {
            bgImageClass = getFlexibilityDisruptionDesktop === 3 ? 'od-flex-bg-c' : 'od-flex-bg-d';
        }

        this.modal = new Modal(
            $modalContainer,
            {
                content: modalContentTemplateBuilder(Odigeo._.extend(flexibilityDisruptionTemplatesKeys, {bgImageClass})),
                button: Odigeo._.get(flexibilityDisruptionTemplatesKeys, 'flexibilityDisruptionPopUpCloseButton', ''),
            },
            {
                template: modalTemplateBuilter,
                fillThePage: false,
                preventContainerTap: false,
                open: {
                    analytics: {
                        action: 'free-cancellation_onload-nag',
                        label: 'free-cancellation_onload-nag_pag:pax',
                    },
                },
                close: {
                    analytics: {
                        action: 'free-cancellation_onload-nag',
                        label: 'free-cancellation_close-nag_pag:pax',
                    },
                },
                button: {
                    analytics: {
                        action: 'free-cancellation_onload-nag',
                        label: 'free-cancellation_close-info_pag:pax',
                    },
                },
            }
        );
        $modalContainer.removeClass('odf-hidden');
        $modalContainer.find(FLEX_MODAL_WHEN_SELECTOR).on('click', this.trackWhenOnClick);
        $modalContainer.find(FLEX_MODAL_WHAT_SELECTOR).on('click', this.trackWhatOnClick);
        $modalContainer.find(FLEX_MODAL_HOW_SELECTOR).on('click', this.trackHowOnClick);
    },

    setFlexibilityDisruptionBanner(templates, keys) {
        const template = Odigeo._.get(templates, 'flexibilityDisruptionBanner', Odigeo._.noop);
        const content = template({texts: keys});
        this.$cachedSelectors.flexibilityDisruptionBanner.html(content);
        this.$cachedSelectors.flexibilityDisruptionBanner.removeClass('odf-hidden');
    },

    setFlightChangeFreeBanner(templates, keys) {
        const template = Odigeo._.get(templates, 'flightChangeFreeBanner', Odigeo._.noop);
        const content = template({texts: keys});
        this.$cachedSelectors.flightChangeFreeBanner.html(content);
        this.$cachedSelectors.flightChangeFreeBanner.removeClass('odf-hidden');
        this.$cachedSelectors.flightChangeFreeBannerAirlineCampaignContainer.removeClass('odf-hidden');
    },

    setAirlineCampaign(templates, keys) {
        const template = Odigeo._.get(templates, 'airlineCampaign', Odigeo._.noop);
        const content = template({texts: keys});
        this.$cachedSelectors.airlineCampaign.html(content);
        this.$cachedSelectors.airlineCampaign.removeClass('odf-hidden');
        this.$cachedSelectors.flightChangeFreeBannerAirlineCampaignContainer.removeClass('odf-hidden');
    },

    setFlightFlexibilityBanner(templates, keys) {
        const template = Odigeo._.get(templates, 'flightFlexibilityBanner', Odigeo._.noop);
        const content = template({texts: keys});
        const isPrimePriceSelected = Odigeo.Membership.isPriceWithoutDiscountSelected !== 'true';
        const isNonPrimeWithFreeChangePriceSelected = !isPrimePriceSelected && flightChangeFreeUtil.isSelectedFlightChangeableForFree();
        this.$cachedSelectors.flightFlexibilityBanner.html(content);

        if (isPrimePriceSelected || isNonPrimeWithFreeChangePriceSelected) {
            this.$cachedSelectors.flightFlexibilityBanner.removeClass('odf-hidden');
        }
    },

    openFlexibilityDisruptionModal() {
        trackingUtils.trackEvent('free-cancellation_trip', 'free-cancellation_more-trip_pag:pax');
        this.modal.then((flexibilityDisruptionModal) => {
            flexibilityDisruptionModal.open(true, true);
        });
    },

    isSmVersion() {
        return this.options.template === 'collapsibleMainSm';
    },

    getTemplateName(name) {
        return `${name + (this.isSmVersion() && !this.popupRender ? 'Sm' : '')}`;
    },

    onAirlineLogoHover(event) {
        $(event.currentTarget)
            .prev(this.selectors.airlineLogoTooltip)
            .toggleClass('open', event.type === 'mouseover');
    },

    renderDestination($container, template) {
        if (this.options.tripToOnWidget) {
            const tripKey = this.keys.yourTripInfo;
            const dest = Odigeo.Utils.replaceCmsKeyArgs(this.keys.yourTripInfo, this.options.destination);
            const isMultidestination = this.options.isMultidestination;
            const isRemoveChangeSearchDesktopPaxActive = Odigeo.AB.isRemoveChangeSearchDesktopPaxActive;
            const transports = this.getTransportsOrdered();
            const changeSearch = transports.includes('train')
                ? this.keys.changeSearchTrain
                : Odigeo.Utils.pluralizeAll(this.keys.changeSearch, this.model.get('flightDetailsDTO').segments.length);
            this.setTemplate($container || this.$cachedSelectors.tripTo, template || this.getTemplateName('tripDestination'), {
                destination: dest,
                key: tripKey,
                change: changeSearch,
                isMultidestination: isMultidestination,
                isRemoveChangeSearchDesktopPaxActive: isRemoveChangeSearchDesktopPaxActive,
                transports,
            });
        }
    },
    activatePopUp() {
        const segments = this.getSegments();
        this.setTemplate(this.$cachedSelectors.popupContainer, this.getTemplateName('popupMain'));
        this.popupRender = true;
        this.fillUnfoldedSummary(segments, this.$cachedSelectors.flightDetailsWrapper);
        this.popupRender = false;
        this.renderDestination(this.$cachedSelectors.yourTripToNag, 'tripDestinationPopup');

        this.flightDetailsPopup = new Odigeo.UIElements.Lightbox(this.$cachedSelectors.popupNag, {
            closeOnOuterClick: true,
            overFullPage: true,
        });
    },
    launchPopup() {
        this.flightDetailsPopup.toggle(true);
    },

    fillTechnicalStops(section, index, $wrapper, hideTimeLine, alignWithTitle) {
        this.fillFlightRowTemplate($wrapper, section, index, null, section.technicalStops[0], false, hideTimeLine, alignWithTitle);
        Odigeo._.each(
            section.technicalStops,
            function(techStop, techStopIndex) {
                if (Odigeo.AB.isFlightSummaryImprovementsV1 || Odigeo.AB.isNewTripDetails) {
                    const stopInfoTechnical = new StopInfoTechnicalView({
                        isVertical: true,
                        section: techStop,
                        alignWithTitle,
                        keys: this.keys,
                    });
                    $wrapper.append(stopInfoTechnical.$el);
                } else {
                    $wrapper.append(this.fillStopInfoTemplate(techStop, 'tech'));
                }

                if (section.technicalStops.length > 1 && techStopIndex < section.technicalStops.length - 1) {
                    this.fillFlightRowTemplate(
                        $wrapper,
                        section,
                        techStopIndex,
                        techStop,
                        section.technicalStops[techStopIndex + 1],
                        true,
                        hideTimeLine,
                        alignWithTitle
                    );
                }
            },
            this
        );
        this.fillFlightRowTemplate(
            $wrapper,
            section,
            index + section.technicalStops.length,
            section.technicalStops[section.technicalStops.length - 1],
            null,
            false,
            hideTimeLine,
            alignWithTitle
        );
    },
    buildTime(time, section) {
        return section.timesUndefined
            ? '--:--'
            : (Odigeo.AB.isUsaTimeFormat)
                ? Odigeo.Utils.formatDate(time, Odigeo.SessionScope.websiteDateFormats.usTimeFormat, true)
                : Odigeo.Utils.formatDate(time, Odigeo.SessionScope.websiteDateFormats.itineraryDetailsTimeFormatMobile, true);
    },
    fillHubOrSmartHubTemplate() {
        return $(
            this.templates.hubOrSmarthub({
                importantText: this.keys.hubImportantText,
                infoText: this.keys.hubText,
            })
        );
    },
    containsHubSections(previous, actual, previousFlightNumber, flightNumber) {
        const flightDetailsDTO = this.model.get('flightDetailsDTO');
        const previousSections = flightDetailsDTO[previous] || this.model.get(previous);
        const actualSections = flightDetailsDTO[actual] || this.model.get(actual);
        return Odigeo._.includes(previousSections, previousFlightNumber) && Odigeo._.includes(actualSections, flightNumber);
    },
    onChangeSearchButton() {
        if (!isSearchBarOpened) {
            isSearchBarOpened = true;
            this.$cachedSelectors.changeFlightButtonText.attr('disabled', 'true');
            this.$cachedSelectors.changeFlight.addClass('disabled');
            Odigeo.trigger(this.widget.id + ':changeCurrentSearch', isSearchBarOpened);
        }
    },
    enableChangeSearch(show) {
        if (!show) {
            this.$cachedSelectors.changeFlightButtonText.removeAttr('disabled');
            this.$cachedSelectors.changeFlight.removeClass('disabled');
            isSearchBarOpened = false;
        }
    },
    areHubSections(previousFlightNumber, flightNumber) {
        const ARRIVAL_SECTIONS = 'hubArrivalSectionsFlightNumbers';
        const DEPARTURE_SECTIONS = 'hubDepartureSectionsFlightNumbers';
        return (
            this.containsHubSections(ARRIVAL_SECTIONS, DEPARTURE_SECTIONS, previousFlightNumber, flightNumber) ||
            this.containsHubSections(DEPARTURE_SECTIONS, ARRIVAL_SECTIONS, previousFlightNumber, flightNumber)
        );
    },
    isHub() {
        const flightDetailsDTO = this.model.get('flightDetailsDTO');
        return Odigeo._.isObject(flightDetailsDTO) && flightDetailsDTO.hub;
    },
    fillStopInfoTemplate(section, stopInfoType, previousFlightNumber) {
        const $stopInfoTemplate = $(
            this.templates.stopInfo({
                section: section,
                stopDuration: Odigeo.Utils.convertMinutesToPattern(section.stopDuration, this.keys.durationShortPattern) || section.stopDuration,
                stopInfoTypeText: stopInfoType ? this.keys.technicalStopInfoType : this.keys.changePlaneStopInfoType,
            })
        );
        if (this.isHub() && this.areHubSections(previousFlightNumber, section.flightNumber)) {
            $stopInfoTemplate.closest('.hub_wrapper').append(this.fillHubOrSmartHubTemplate(section));
        }
        return $stopInfoTemplate;
    },
    fillSectionTemplate(index, segment, section, $wrapper, hideTimeLine, alignWithTitle) {
        if (index !== 0) {
            if (Odigeo.AB.isFlightSummaryImprovementsV1 || Odigeo.AB.isNewTripDetails) {
                const previousSection = segment.sections[index - 1];
                const flightDetailsDTO = this.model.get('flightDetailsDTO');
                const hubInsurance =
                    Odigeo._.isObject(flightDetailsDTO) && flightDetailsDTO.hubInsuranceOfferDTO ? flightDetailsDTO.hubInsuranceOfferDTO : {};
                const stopInfo = new StopInfoView({
                    isVertical: this.options.isDesktop && this.options.isResults,
                    previousSection,
                    section,
                    isHub: this.isHub() && this.areHubSections(previousSection.flightNumber, section.flightNumber),
                    hubInsurance,
                    alignWithTitle,
                    keys: this.keys,
                    model: this.detailsModel.get('drawer'),
                });
                $wrapper.append(stopInfo.$el);
            } else {
                $wrapper.append(this.fillStopInfoTemplate(section, null, segment.sections[index - 1].flightNumber));
            }
        }
        if (Odigeo._.isEmpty(section.technicalStops)) {
            this.fillFlightRowTemplate($wrapper, section, index, null, null, null, hideTimeLine, alignWithTitle);
        } else {
            this.fillTechnicalStops(section, index, $wrapper, hideTimeLine, alignWithTitle);
        }
    },

    getBaggageMessage(baggageIncluded, isBaggageIncluded) {
        const baggageIncludedKey = Odigeo.AB.isNewBagInfoItineraries ? this.keys.checkinBagIncluded : this.keys.baggageIncluded;
        const baggageNotIncludedKey = Odigeo.AB.isNewBagInfoItineraries ? this.keys.cabinBagIncluded : this.keys.baggageNotIncluded;
        const baggageIconCommonClasses = Odigeo.AB.isNewBagInfoItineraries
            ? 'odf-icon odf-icon-xl odf-icon-baggage'
            : 'odf-icon odf-icon-2xl odf-icon-baggage';
        const baggageIconSize = Odigeo.AB.isNewBagInfoItineraries
            ? isBaggageIncluded ? '-large' : '-medium'
            : baggageIncluded === 'CHECK_IN_INCLUDED' ? '-large' : '-medium';
        const baggageMessageText = Odigeo.AB.isNewBagInfoItineraries
            ? isBaggageIncluded ? baggageIncludedKey : baggageNotIncludedKey
            : baggageIncluded === 'CHECK_IN_INCLUDED' ? baggageIncludedKey : baggageNotIncludedKey;
        return {
            baggageMessageIcon: `<span class="${baggageIconCommonClasses}${baggageIconSize}"></span>`,
            baggageMessageText,
        };
    },

    fillItineraryDetailsTemplate(segment) {
        const isNewTripDetailsResultsDesktop = Odigeo.AB.isNewTripDetails && this.options.isDesktop && this.options.isResults;
        const wrapperClass = isNewTripDetailsResultsDesktop ? '' : 'od-collapsible-box';
        const $itineraryDetailsTemplate = $(this.templates.itineraryDetails({wrapperClass}));
        const $sectionWrapper = $itineraryDetailsTemplate.find('.section_wrapper');
        const alignWithTitle = this.options.alignWithTitle;
        const hideTimeLine = !segment.stopOvers.length && !segment.technicalStops && this.options.shouldHideTimeline;
        Odigeo._.each(
            segment.sections,
            function(section, index) {
                this.fillSectionTemplate(index, segment, section, $sectionWrapper, hideTimeLine, alignWithTitle);
            },
            this
        );

        if (Odigeo.SessionScope.flow === 'mobile' || isNewTripDetailsResultsDesktop) {
            this.fillBaggageInformation(segment, $itineraryDetailsTemplate);
        }

        return $itineraryDetailsTemplate;
    },

    fillBaggageInformation(segment, $itineraryDetailsTemplate) {
        const {isBaggageIncluded, baggageMessageText, bagContext, baggageMessageIcon, hasSmallBagInCabin,
            departureIncludedBags, isBaggageCabinIncluded} = this.getBaggageTemplateData(segment);
        const $baggageTemplate = $itineraryDetailsTemplate.find('.baggage_detail_wrapper');

        if (Odigeo.AB.isNewBagInfoItineraries) {
            this.setTemplate($baggageTemplate, 'newBaggageDetail', {
                isBaggageIncluded,
                baggageMessageText,
                bagContext,
                baggageMessageIcon,
                departureIncludedBags,
                isBaggageCabinIncluded,
                hasSmallBagInCabin,
            });
        } else {
            this.setTemplate($baggageTemplate, 'baggageDetail', {
                isBaggageIncluded,
                baggageMessageText,
            });
        }
    },
    getBaggageTemplateData(segment) {
        const includedBags = this.model.get('includedBags') || [];
        const includedBag = includedBags[0] || {};
        const descriptorIncludedInPrice = includedBag.baggageDescriptorIncludedInPrice || {};
        const departureIncludedBags = descriptorIncludedInPrice.pieces;
        const carrierCode = segment.carrier ? segment.carrier.code : '';
        const smallBagOnly = !!(segment.baggage && segment.baggage.smallBagOnly);
        const hasSmallBagInCabin = airlineUtils.isCarrierWithSmallBagInCabin(carrierCode) || smallBagOnly;
        const baggageIncludedType = segment.baggage ? segment.baggage.includedType : '';
        const isBaggageIncluded = baggageIncludedType === 'CHECK_IN_INCLUDED'
            || baggageIncludedType === 'CABIN_INCLUDED' && departureIncludedBags >= 1;
        const isBaggageCabinIncluded = baggageIncludedType === 'CABIN_INCLUDED';
        const {baggageMessageIcon, baggageMessageText} = hasSmallBagInCabin && !isBaggageIncluded
            ? this.getSmallBagMessage() : this.getBaggageMessage(baggageIncludedType, isBaggageIncluded);
        const bagContext = !isBaggageIncluded
            ? hasSmallBagInCabin ? this.keys.smallBagUnderSeat : this.keys.cabinBagUnderSeat
            : '';
        return {isBaggageIncluded, isBaggageCabinIncluded, baggageMessageText, baggageMessageIcon,
            bagContext, departureIncludedBags, hasSmallBagInCabin};
    },

    getSmallBagMessage() {
        const baggageMessageIcon = `<span class="odf-icon odf-icon-2xl odf-icon-baggage-small"></span>`;
        const baggageMessageTextA = this.keys.smallBaggageIncluded;
        const baggageMessageTextB = this.keys.smallBagIncluded;
        const baggageMessageTextUS = this.keys.smallBagIncludedUS;
        const baggageMessageText = Odigeo.AB.isNewBagInfoItineraries
            ? Odigeo.SessionScope.locale === 'en_US' ? baggageMessageTextUS : baggageMessageTextB
            : baggageMessageTextA;
        return {baggageMessageIcon, baggageMessageText};
    },

    isCharter(segment) {
        return segment.charter && segment.charterType && 'NOT_CHARTER' !== segment.charterType;
    },

    fillSegmentItemTemplate(segment, index) {
        const $segmentItemTemplate = this.getSegmentItem(segment);
        let $segmentItemDesktop;

        $segmentItemTemplate.find('.itinerary_details_wrapper').append(this.fillItineraryDetailsTemplate(segment));
        $segmentItemDesktop = $segmentItemTemplate.find('.unfolded_details_desktop');
        if ($segmentItemDesktop.length && !this.options.isResults) {
            $segmentItemDesktop.append(this.createFoldedSegmentTemplate(segment, index));
        }
        return $segmentItemTemplate;
    },

    getSegmentItem(segment) {
        return $(
            this.templates.segmentItem({
                segment: segment,
                isCharter: this.isCharter(segment),
                hasToShow: (segment.allStops > 0 || this.options.showOnlyDetails) && this.options.isDesktop,
                itineraryRowClasses: Odigeo.AB.isNewTripDetails || this.options.template === 'resultsPopup' ? '' : 'odf-bg-secondary',
                itineraryDetailsWrapperClass:
                    Odigeo.AB.isNewTripDetails && this.options.isDesktop && !this.options.showOnlyDetails ? 'od-collapsible-section-box' : '',
            })
        );
    },

    getSegmentName(index, tripType) {
        return tripTypeUtils.isMultiFlightType(tripType)
            ? Odigeo.Utils.replaceCmsKeyArgs(this.keys.segmentname, this.keys[`multipleDestination${index}`])
            : this.keys[`segmentname${index}`];
    },

    fillSegmentHeaderTemplate(segment, index, tripType) {
        const $segmentHeaderTemplate = this.getSegmentHeader(segment, index, tripType);
        return this.renderSegmentItem($segmentHeaderTemplate, segment, segment.visible, index);
    },

    fillCollapsibleBottomTemplate() {
        const keys = this.keys;
        const flightDetailsDTO = this.model.get('flightDetailsDTO');
        const segments = this.getSegments();
        const hasChangeOfCountryInAnySection = stopInfoUtils.hasChangeOfCountryInAnySection(segments);
        const isVIN = flightDetailsDTO.isVIN;
        const shouldShowTravelRestrictionMessage = isVIN && hasChangeOfCountryInAnySection;
        this.$cachedSelectors.collapsibleButton.append(
            this.templates[this.getTemplateName('collapsibleBottom')]({
                shallShowDetails: shallShowDetails ? '' : 'odf-hidden',
                shouldShowTravelRestrictionMessage,
                keys,
            })
        );
    },
    replaceSuscriptionKeys(keys, membershipSubscriptionPrice) {
        const forceSelectionPrimSectionKey = keys.forceSelectionPrimeSectionBenefitThree;
        const keySubscriptionFee = keys.primeResultsSubscriptionYear ? keys.primeResultsSubscriptionYear : keys.primeResultsSubscription;
        keys.forceSelectionPrimeSectionBenefitOne = Odigeo.Utils.replaceCmsKeyArgs(
            keys.forceSelectionPrimeSectionBenefitOne,
            membershipSubscriptionPrice
        );
        keys.forceSelectionPrimeSectionBenefitTwo = Odigeo.Utils.replaceCmsKeyArgs(
            keys.forceSelectionPrimeSectionBenefitTwo,
            membershipSubscriptionPrice
        );
        keys.forceSelectionPrimeSectionBenefitThree = Odigeo.Utils.replaceCmsKeyArgs(forceSelectionPrimSectionKey, membershipSubscriptionPrice);
        keys.primeResultsSubscription = Odigeo.Utils.replaceCmsKeyArgs(keySubscriptionFee, membershipSubscriptionPrice);
    },
    addNewTemplateData(data, keys) {
        if (Odigeo.AB.isPaxPrimeForceSelectionActive) {
            this.replaceSuscriptionKeys(keys, data.membershipSubscriptionPriceFmtd);
        }
        const doRenderPromotionalMessage =
            this.widget.model.renderPromotionalMessage || ((Odigeo.AB.isChangeFlightFreeChargeMobile || Odigeo.AB.isPrimeDays)
                && flightChangeFreeUtil.isSelectedFlightChangeableForFree(data.flightNumbers));
        data = Odigeo._.extend(data, {
            promotionalMessageClass: doRenderPromotionalMessage ? '' : 'odf-hidden',
            prismaHeader: Odigeo.AB.prismaHeader,
        });
    },
    fillFooterTemplate(data) {
        let footerTemplate;

        if (this.options.template === NEW_DETAILS_TEMPLATE) {
            this.addNewTemplateData(data, this.keys);
            if (Odigeo.AB.isPaxPrimeForceSelectionActive) {
                footerTemplate = this.templates.forceSelectionFooter(Odigeo._.extend(data, {keys: this.keys}));
            } else {
                const strongCss = Odigeo.AB.isCssVariationMobile ? '' : 'odf-strong';
                footerTemplate = this.templates.resultsNewFooterAb(Odigeo._.extend(data, {keys: this.keys, strongCss}));
            }
        } else {
            const strongCss = Odigeo.AB.isCssVariationMobile ? 'odf-text-2xlplus' : 'odf-h1';
            footerTemplate = this.templates.resultsFooter(Odigeo._.extend(data, {strongCss}));
        }
        this.$cachedSelectors.resultsFooterContainer.html(footerTemplate);
    },
    onForceSelectionLabel(e) {
        const trackingOptionLabel = $(e.currentTarget).data('prime-option');
        trackingUtils.trackEvent('unlocked', `${trackingOptionLabel}_price_selected`);
        this.$cachedSelectors.resultsContinueButton.prop('disabled', false);
    },
    createFoldedSegmentTemplate(segment, index) {
        const departureSection = segment.sections[0];
        const arrivalSection = segment.sections[segment.sections.length - 1];
        let hasDetails;
        const stopsKey = this.keys.stopsKey;
        const carrierCode = Odigeo._.get(segment, 'carrier.code');
        const smallBagOnly = !!(segment.baggage && segment.baggage.smallBagOnly);
        const hasSmallBagInCabin = airlineUtils.isCarrierWithSmallBagInCabin(carrierCode) || smallBagOnly;
        const transportType = this.getTransportType();
        const pureTrain = transportType === 'TRAIN';
        const hasTrains = transportType !== 'PLANE';
        const includedBags = this.model.get('includedBags') || [];
        const includedBag = includedBags[0] || {};
        const descriptorIncludedInPrice = includedBag.baggageDescriptorIncludedInPrice || {};
        const departureIncludedBags = descriptorIncludedInPrice.pieces;
        hasStops = hasStops || segment.allStops > 0;
        hasDetails = hasStops || this.isHub() || this.isCharter(segment);
        shallShowDetails = hasDetails && this.options.isDesktop;
        const commercialBrandCode = Odigeo._.get(segment.sections[0], 'commercialBrand.code');
        const trainCode = commercialBrandCode ? commercialBrandCode : carrierCode;

        return $(
            this.templates[this.getTemplateName('foldedSegment')]({
                departureIncludedBags: departureIncludedBags,
                departureDate: Odigeo.Utils.formatDate(departureSection.departureTime, 'extendedDayDayMonth', true),
                arrivalDate: Odigeo.Utils.formatDate(arrivalSection.arrivalTime, 'extendedDayDayMonth', true),
                differenceInDays: Odigeo.Utils.getDifferenceInDays(departureSection.departureTime, arrivalSection.arrivalTime),
                departureTime: this.buildTime(departureSection.departureTime, departureSection),
                departureCity: departureSection.departureLocation.city,
                departureCountry: departureSection.departureLocation.country,
                departureIata: departureSection.departureLocation.iata,
                arrivalTime: this.buildTime(arrivalSection.arrivalTime, arrivalSection),
                arrivalCity: arrivalSection.arrivalLocation.city,
                arrivalCountry: arrivalSection.arrivalLocation.country,
                arrivalIata: arrivalSection.arrivalLocation.iata,
                arrivalLocation: arrivalSection.arrivalLocation,
                departureLocation: departureSection.departureLocation,
                arrivalTerminal: arrivalSection.arrivalTerminal,
                departureTerminal: departureSection.departureTerminal,
                stops: Odigeo.Utils.pluralizeAll(stopsKey, segment.allStops),
                stopsNumber: segment.allStops,
                numStopsColorClass: segment.allStops === 0 ? 'odf-text-positive' : '',
                segmentName: this.getSegmentName(index, this.model.get('tripType')),
                carrierCode: departureSection.carrier.code,
                trainCode: trainCode,
                carrierName: departureSection.carrier.name,
                section: departureSection,
                isHub: this.isHub(),
                hubOrSmartHubIcon: this.getHubOrSmartHubIconClass(index, this.model.get('tripType')),
                isCharter: this.isCharter(segment),
                keys: this.keys,
                hasTrains: hasTrains,
                pureTrain: pureTrain,
                hasSmallBagInCabin: hasSmallBagInCabin,
                shallShowDetails: shallShowDetails ? '' : 'odf-hidden',
                baggageIncluded: segment.baggage.includedType,
                duration: Odigeo._.isString(segment.duration)
                    ? segment.duration
                    : Odigeo.Utils.convertMinutesToPattern(segment.duration, this.keys.durationShortPattern),
                onlyDetails: this.options.showOnlyDetails,
                isBaggageInfoInNewSummary: Odigeo.AB.isBaggageInfoInNewSummary,
                uniqueSegmentCarriers: this.getUniqueSegmentCarriers(segment.sections),
            })
        );
    },
    getUniqueSegmentCarriers(sections) {
        const logosNumberLimit = 2;
        const uniqueCarriers = [...new Set(sections.filter((section) => section.carrier).map((section) => section.carrier.code))];
        return uniqueCarriers.slice(0, logosNumberLimit);
    },
    getHubOrSmartHubIconClass(index, tripType) {
        const iconClasses = ['odf-icon-plane-going', 'odf-icon-plane-returning'];
        return tripTypeUtils.isMultipleDestinations(tripType) ? 'odf-icon-flight' : iconClasses[index];
    },
    fillFoldedSegmentTemplate(segment, index) {
        const $segmentHeaderTemplate = this.createFoldedSegmentTemplate(segment, index);
        if (this.isDeutscheBahnSegment(segment.sections) && !this.options.isResults) {
            fareOptionInfoFactory.create({el: $segmentHeaderTemplate.find('.fare_option_info')});
        }
        return this.renderSegmentItem($segmentHeaderTemplate, segment, segment.visible && !this.isSmVersion(), index);
    },

    isDeutscheBahnSegment(sections) {
        const uniqueSegmentCarriers = this.getUniqueSegmentCarriers(sections);
        return uniqueSegmentCarriers.length === 1 && uniqueSegmentCarriers[0] === DEUTSCHE_BAHN;
    },

    renderSegmentItem($parent, segment, shouldRender, index) {
        if (shouldRender) {
            const $wrapper = $parent.closest('.collapsible_segment_wrapper');
            $wrapper.append(this.fillSegmentItemTemplate(segment, index));
        }
        return $parent;
    },

    fillFareConditions(segments) {
        let commercialBrandTexts = '';
        const getTitleElement = (text) => `<span class="odf-text-md odf-text-strong">${text}</span>`;
        const getBodyElement = (text) => `<div class="odf-text-sm odf-text-soft odf-space-inner-bottom-m">${text}</div>`;
        segments.forEach((segment, indexSegment) => {
            segment.sections.forEach((section) => {
                const brandCode = section.commercialBrand?.code || section.carrier?.code;
                const fareTitleContent = this.keys[`fareConditions${brandCode}Title`];
                const fareDescriptionContent = this.keys[`fareConditions${brandCode}Description`];

                if (
                    !isNullOrUndefined(fareDescriptionContent) &&
                    fareDescriptionContent !== ''
                ) {
                    const text = `${getTitleElement(this.keys[`segmentname${indexSegment}`])}:
                        ${getTitleElement(fareTitleContent)} ${getBodyElement(fareDescriptionContent)}`;
                    commercialBrandTexts = commercialBrandTexts.concat(text);
                }
            }, this);
            if (indexSegment < segments.length -1 && commercialBrandTexts.length > 0) {
                commercialBrandTexts = commercialBrandTexts.concat(`<div class="odf-stroke-primary odf-space-outer-bottom-m"></div>`);
            }
        }, this);

        if (commercialBrandTexts.length > 0) {
            this.$cachedSelectors.fareConditionsContainer.append($(
                this.templates[this.getTemplateName('fareConditions')]({commercialBrandTexts})
            ));
        }
    },

    fillFoldedSummary(segments, $appendTo) {
        const collapsibleFlightDetailsCollapsibleContent = $appendTo || this.$el.find('.collapsible_flight_details_wrapper .collapsible_content');

        Odigeo._.each(
            segments,
            function(segment, index) {
                collapsibleFlightDetailsCollapsibleContent.append(this.fillFoldedSegmentTemplate(segment, index));
            },
            this
        );
        return collapsibleFlightDetailsCollapsibleContent;
    },

    getSegments() {
        const flightDetailsDTO = this.model.get('flightDetailsDTO');
        return Odigeo._.isObject(flightDetailsDTO) && flightDetailsDTO.segments ? flightDetailsDTO.segments : null;
    },

    initTemplate() {
        const segments = this.getSegments();
        const checkIfShowIpTouchpoint = this.model.checkShowIpTouchpoint();
        if (Odigeo._.isObject(segments)) {
            if (this.options.isMeta) {
                const productName = Odigeo.Utils.getProductName(segments);
                trackingUtils.setCustomDimension('selection_type', productName);
            }
            this.renderComponents(segments);
            if (isDynpack) {
                this.renderFlightChangeFreeBannerWhenAvailable(segments);
            }
            this.updateDomSelectorsToCache();
            this.bindViewEvents();
            if (!this.options.manualDisplay) {
                this.expandOrCollapseFlightDetails(!isFolded, 'expandPanel');
            }
            this.toggleFoldedElements(isFolded);
            if (this.options.isResults && Odigeo._.has(this.model.changed, 'flightDetailsDTO')) {
                this.toggleViewPortLock(true);
                this.toggleResultsPopup(true);
                if (Odigeo.Membership.isPrimeUkResultsBoxMobile) {
                    this.trackingCardSelection();
                }
                this.resultsLightbox(this.getCssClassForLightbox(segments));
            }
            this.enhanceHint();
            if (this.isSmVersion()) {
                this.activatePopUp();
            }
            this.showBoardingOptions();
            if (this.shouldShowFareType(segments)) {
                this.renderFareType();
            }
        }
        this.renderDestination();
        if (checkIfShowIpTouchpoint) {
            const toIpTouchpoint = ipTouchpoint.create({el: '#ip-touchpoint'});
            toIpTouchpoint.execute('render');
        }
        this.renderNewFlightInfo();

        if (Odigeo.AB.isSummaryContinueButtonLoading && this.model.get('flightDetailsDTO')) {
            Odigeo.trigger(`${this.widget.id}:initializeLoadingButton`, {
                options: this.getBtnLoadingOptions(),
            });
        }
        if (Odigeo.Membership.isPrimeInFlightSummaryMetasMobile) {
            this.renderPrimeSelection();
        }
    },

    getCssClassForLightbox(segments) {
        return Odigeo._.isObject(segments[0]) && segments[0].stops > 0 ? 'od-collapsible-results-box-large' : '';
    },

    getSegmentCarriers(segments = []) {
        return [...new Set(segments.map((segment) => (segment.carrier ? segment.carrier.code : '')))];
    },

    renderComponents(segments) {
        this.$cachedSelectors.flightDetailsWrapper = Odigeo.UIElements.collapsive.enhance(this.$cachedSelectors.flightDetailsWrapper, {
            triggerLauncher: 'expanded-summary',
            triggerEvents: true,
            initiallyExpanded: this.options.hideCollapsible,
        });

        this.$cachedSelectors.collapsibleFlightDetailsWrapper = Odigeo.UIElements.collapsive.enhance(
            this.$cachedSelectors.collapsibleFlightDetailsWrapper,
            {
                triggerLauncher: 'collapsed-summary',
                triggerEvents: true,
                initiallyExpanded: this.options.isResults,
            }
        );
        this.fillUnfoldedSummary(segments);
        this.setAdditionalStyles();
        if (
            !this.options.isTrafficFromMetas &&
            this.options.isTrainABActive &&
            !(Odigeo.AB.isNewTripDetails && Odigeo.SessionScope.flow === 'mobile')
        ) {
            this.renderHeader();
        }

        if (!this.options.hideCollapsible) {
            this.fillFoldedSummary(segments);
            this.fillCollapsibleBottomTemplate();
            this.updateDomSelectorsToCache();
            this.bindViewEvents();
            this.expandOrCollapseFlightDetails(!isFolded, 'expandPanel');
            this.toggleFoldedElements(isFolded);
            this.enhanceHint();
        }

        if (Odigeo.AB.isFareConditionsRails) {
            this.fillFareConditions(segments);
        }

        if (this.options.isResults) {
            if (!this.options.hideFooter) {
                this.fillFooterTemplate(this.model.getFooterData());
            }
            Odigeo.trigger(this.widget.id + ':pushState', {});
            Odigeo.trigger(this.widget.id + ':listenRouteChangeToClosePopup');
        } else {
            this.adjustForOneWay();
            this.adjustForMultiTrip(segments.length);
        }
    },

    trackingOnce: Odigeo._.once(function() {
        trackingUtils.trackEvent('on_load', 'xfaring_info_loaded');
    }),

    enhanceHint() {
        if (this.$cachedSelectors.importantInfo.length && this.widget.options.importantInfoTracking) {
            this.trackingOnce();
        }
        Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), this.$el.find('.owc_special_rules'), {
            events: {
                tap: true,
            },
            googleAnalyticsOnOpen: {
                type: 'trackEvent',
                data: {
                    action: 'xfaring_info',
                    label: 'xfaring_info_clicked',
                },
            },
            trigger: 'flightDetails:owcSpecialRules',
        });
    },
    scrollToTop(isFolded) {
        if (!isFolded) {
            Odigeo.Utils.scrollToElement(this.$el);
        }
    },
    toggleFoldedElements(isFolded) {
        this.$cachedSelectors.toggleFlightDetails.toggleClass('folded', isFolded);
        this.$cachedSelectors.bottomRowMessage.toggleClass('odf-hidden');
        this.$cachedSelectors.toggleRowButtons.toggleClass('folded', isFolded);
    },

    isDisabledCollapsible() {
        return this.options.isResults || this.options.disableCollapsible;
    },

    toggleFlightDetails(e) {
        if ((hasStops || Odigeo.SessionScope.flow === 'mobile') && !this.isDisabledCollapsible() && !$(e.target).hasClass('prevent_toggle')) {
            trackingUtils.trackEvent('summary_widget', isFolded ? 'summary_details_open' : 'summary_details_close');
            this.expandOrCollapseFlightDetails(!isFolded, 'collapsePanel');
            this.scrollToTop(isFolded);
            isFolded = !isFolded;
            this.toggleFoldedElements(isFolded);
        }
    },
    expandOrCollapseFlightDetails(isFolded, action) {
        const $el = isFolded ? this.$cachedSelectors.flightDetailsWrapper : this.$cachedSelectors.collapsibleFlightDetailsWrapper;
        $el.trigger(action);
    },
    toggleResultsPopup(value) {
        Odigeo.trigger(`${this.widget.id}:openOrCloseFlightInfoPopup`, value);
        this.$cachedSelectors.collapsibleResultsPopup.toggleClass('open opened', value);
        this.$cachedSelectors.collapsibleContent.toggle(value);
    },
    closeFlightSummary(isFromBrowserBackButton) {
        if (Odigeo.AB.isPaxPrimeForceSelectionActive) {
            this.$cachedSelectors.forceSelectionBackground.removeClass('open');
        }
        this.toggleViewPortLock(false);
        this.toggleResultsPopup(false);
        this.dealWithCloseFlightSummary(isFromBrowserBackButton);
        this.model.clear();
    },
    onResultsCloseButton(e) {
        e.preventDefault();
        e.stopPropagation();
        this.closeFlightSummary(false);
    },
    onResultsContinueButton({upsellTouchpointClicked, primeSubscriptionSelected}) {
        let bookingData = this.model.getBookingData();
        const {membershipPriceDisplayMobile} = Odigeo.Membership;
        const {isPaxPrimeForceSelectionActive, isPreCreateShoppingCartInDetails} = Odigeo.AB;
        bookingData = {...bookingData, ...upsellTouchpointClicked};

        if (isPaxPrimeForceSelectionActive) {
            const optionSelected = this.$cachedSelectors.forceSelectionContainer.find('[name="force-selection-option"]:checked');
            if (optionSelected.length > 0) {
                if (optionSelected.val() === 'nonmember') {
                    Odigeo.trigger('book-flight-manager:cancelBookFlightHandler');
                    bookingData.isPriceWithoutDiscountSelected = true;
                }
                this.bookFlight(bookingData);
                trackingUtils.trackEvent('unlocked', `pre-select-info_submitted_${optionSelected.val()}`);
            } else {
                this.showForceSelection();
            }
        } else {
            if (
                (isPreCreateShoppingCartInDetails && membershipPriceDisplayMobile === 'FILTER') ||
                membershipPriceDisplayMobile === 'DUAL_DISPLAY' ||
                membershipPriceDisplayMobile === 'TOGGLE_BUTTON'
            ) {
                trackingUtils.trackEvent('unlocked', `pre-select-info_submitted_${bookingData.primeOptionSelected}`);
            }
            this.bookFlight(bookingData);
        }
    },
    getBtnLoadingOptions() {
        return {
            success: this.onResultsContinueButton.bind(this),
            error: this.onCreateShoppingCartError.bind(this),
        };
    },
    onCreateShoppingCartError() {
        Odigeo.trigger('book-flight-manager:handleCreateShoppingCartError');
    },
    showForceSelection() {
        this.$cachedSelectors.forceSelectionContainer.find('[value="subscription"]').prop('checked', true);
        this.$cachedSelectors.forceSelectionBackground.addClass('open');
        this.$cachedSelectors.forceSelectionContainer.addClass('open');
    },
    bookFlight(bookingData) {
        Odigeo.trigger(`${this.widget.id}:detailsContinueButton`);
        if (isNewPopupEnabled && !Odigeo.AB.isSummaryContinueButtonLoading) {
            this.toggleResultsPopup(false);
        } else if (!isNewPopupEnabled) {
            this.toggleViewPortLock(false);
        }
        Odigeo.trigger(`${this.widget.id}:bookFlight`, bookingData);
    },
    trackCloseEvent() {
        if (isNewPopupEnabled) {
            trackingUtils.trackEvent('close_summary', 'close_summary_back', 'flights_summary');
        } else {
            trackingUtils.trackEvent('show_details', 'show_details_close_popup');
        }
    },
    toggleViewPortLock(value) {
        Odigeo.trigger(this.widget.id + ':toggleViewPortLock', value);
    },
    showBoardingOptions() {
        const data = this.model.get('boardingOptions');
        const carrierList = Odigeo._.get(data, 'carrierList', []);
        const sections = Odigeo._.map(
            carrierList,
            function(carrier) {
                return this.$el.find('.collapse_baggage_section_' + carrier.toLowerCase());
            },
            this
        );

        if (!Odigeo._.isUndefined(data)) {
            this.updateDomSelectorsToCache();
            this.setBoardingOptionsContainers(data, sections);
            this.hideBaggageIncludedLabel();
            this.initBoardingOptionsHint(data, sections);
        }
    },
    setBoardingOptionsContainers: function(data, sections) {
        const showWarning = data.showWarning || false;
        const hint = data.hint;

        Odigeo._.forEach(sections, (section) => {
            section.find('.collapse_baggage_warning').removeClass('odf-hidden');
            section.find('.collapse_baggage_warning_icon').toggleClass('odf-hidden', !showWarning);
            section.find('.collapse_baggage_warning_content').html(data.text);
            section.find('.collapse_baggage_warning_hint').toggleClass('odf-hidden', Odigeo._.isEmpty(hint));
            section.find('.collapse_baggage_warning_hint_content').html(hint);
            section.find('.collapse_baggage_warning_hint_title').html(data['hint_title']);
        });
    },
    hideBaggageIncludedLabel: function() {
        const data = this.model.get('boardingOptions');
        const carrierList = Odigeo._.get(data, 'carrierList', []);

        carrierList.forEach((carrier) => {
            this.$el.find('.collapse_baggage_included_' + carrier.toLowerCase()).addClass('odf-hidden');
        });
    },
    initBoardingOptionsHint: function(data, sections) {
        if (!Odigeo._.isEmpty(data.hint)) {
            Odigeo._.forEach(sections, (section) => this.initBoardingOptionsHintSection(data, section), this);
        }
    },
    initBoardingOptionsHintSection: function(data, section) {
        if (!Odigeo._.isEmpty(data.hint)) {
            Odigeo._.each(
                section.find('.collapse_baggage_warning_hint'),
                function(row) {
                    Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), row, {
                        events: {
                            tap: true,
                        },
                        googleAnalyticsOnOpen: this.getBoardingOptionsTrackingData(data),
                    });
                },
                this
            );
        }
    },
    getBoardingOptionsTrackingData(data) {
        const trackingData = Odigeo._.get(data, 'trackingData', {});

        return {
            type: 'trackEvent',
            data: {
                action: 'cabin_bag_message',
                label: [
                    'cabin_bag_message_info-none_legs:',
                    trackingData.totalNumber,
                    '-',
                    trackingData.carrierNumber,
                    '_carrier:',
                    data.carrierCode,
                ].join(''),
            },
        };
    },

    setAdditionalStyles() {
        const decorationStyles = Odigeo.AB.isCobaltBoxVariant ? 'prisma-elevation-1' : 'odf-box odf-box-primary';
        this.$cachedSelectors.collapsibleFlightMainWrapper.toggleClass(`${decorationStyles}`, !this.options.notShowAsBox);
        this.$cachedSelectors.flightDetailsWrapper.toggleClass('od-collapsible-cursor-default', !!this.options.defaultCursor);
        this.$cachedSelectors.itineraryDetailsWrapper.toggleClass('odf-bg-base', !!this.options.whiteBackground);
        this.$cachedSelectors.carrierSeatTypeInfo.toggleClass('odf-space-outer-top-s', !!this.options.spaceDurationCarrier);
        this.$cachedSelectors.flightDetailsWrapper.toggleClass('odf-space-outer-bottom-s', !!this.options.marginBottom);
    },

    renderNewFlightInfo() {
        Odigeo.trigger(this.widget.id + ':renderNewFlightInfo');
    },

    generateSectionId({id}, index, isTechnicalStop) {
        return `section-${id}-${index}${isTechnicalStop ? '-tech' : ''}-${Odigeo.History.getPageNameFromFragment()}`;
    },
    trackingCardSelection() {
        const isUserLogged = () => hasRememberMeCookie();
        const {isPriceWithoutDiscountSelected} = this.model.getBookingData();
        const fare = isPriceWithoutDiscountSelected ? 'standard' : 'prime';
        const userLog = isUserLogged() ? '' : 'no-';
        trackingUtils.trackEventWithCategory('flights_results', 'prime', `continue_with_${fare}_sce:${userLog}log_pag:res`);
    },
};
